<!-- 发票信息 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    ref="topData"
    :rules="rules"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  // import API from '@/api/wareHouse/mcInbound.js';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'baseInfo',
    components: {
      BaseForm,
    },
    props: {
      costInfo: {
        type: Object,
        default: () => {},
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      options() {
        // const data = this.formData;
        return [
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.inboundNo"),
          //   prop: "inboundNo",
          //   clearable: true,
          //   placeholder: this.$t("mcInboundEdit.baseInfo.defaultPlaceholder"),
          //   disabled: true,
          // }, //委托加工入库单号
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.inboundQuantity"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.inboundQuantityPlaceholder"),
          //   prop: "inboundQuantity",
          //   clearable: true,
          //   disabled: true,
          // }, //商品入库数量
          // {
          //   type: "input",
          //   disabled:true,
          //   label: this.$t("mcInboundEdit.baseInfo.settlementPrice"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.settlementPricePlaceholder"),
          //   prop: "settlementPrice",
          //   clearable: true,
          // }, //商品单价
          // {
          //   type: "input",
          //   disabled:true,
          //   label: this.$t("mcInboundEdit.baseInfo.settlementAmount"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.settlementAmountPlaceholder"),
          //   prop: "settlementAmount",
          //   clearable: true,
          // }, //商品金额
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.distributionInboundNo"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.distributionInboundNoPlaceholder"),
          //   prop: "distributionInboundNo",
          //   clearable: true,
          //   disabled: true,
          // }, //物流入库单号
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.instructionNo"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.instructionNoPlaceholder"),
          //   prop: "instructionNo",
          //   clearable: true,
          //   disabled: true,
          // }, //供应商发货指令号
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.productNo"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.defaultPlaceholder"),
          //   prop: "productNo",
          //   clearable: true,
          //   disabled: true,
          // }, //商品编码
          // {
          //   type: "date",
          //   label: this.$t("mcInboundEdit.baseInfo.inboundCreateDate"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.inboundCreateDatePlaceholder"),
          //   prop: "inboundCreateDate",
          //   disabled:true,
          //   clearable: true,
          // }, //制单日期
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.productDesc"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.defaultPlaceholder"),
          //   prop: "productDesc",
          //   clearable: true,
          //   disabled: true,
          // }, //商品描述
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.contractQuantity"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.defaultPlaceholder"),
          //   prop: "contractQuantity",
          //   clearable: true,
          //   disabled: true,
          // }, //合同数量
          {
            type: 'date',
            label: this.$t('mcInboundEdit.baseInfo.inboundDate'),
            placeholder: this.$t('mcInboundEdit.baseInfo.inboundDatePlaceholder'),
            prop: 'inboundDate',
            required: true,
            clearable: true,
          }, //商品入库日期
          {
            type: 'searchTable',
            prop: 'partnerName',
            isMultiple: true,
            label: this.$t('mcInboundEdit.baseInfo.partnerNo'),
            // name: 'partnerName',
            // getName: 'partnerZhName',
            // code: 'partnerNo',
            // getCode: 'partnerNo',
            currentValue: this.formData.partnerName,
            extraData: {
              departmentCode: this.formData.departmentCode,
              companyCode: this.formData.companyCode,
            },
            searchType: 'supplier',
            disabled: true,
          }, // 供应商
          {
            type: 'searchTable',
            label: this.$t('mcInboundEdit.baseInfo.inboundStorageNo'),
            prop: 'inboundStorageName',
            placeholder: this.$t('mcInboundEdit.baseInfo.inboundStorageNoPlaceholder'),
            searchType: 'warehouse',
            // name: 'inboundStorageName',
            // getName: 'storageName',
            // code: 'inboundStorageNo',
            // getCode: 'storageCode',
            required: true,
            currentValue: this.formData.inboundStorageName,
            isMultiple: true,
          }, //商品入库仓库
          {
            type: 'searchTable',
            label: this.$t('mcInboundEdit.baseInfo.outboundStorageNo'),
            prop: 'outboundStorageName',
            placeholder: this.$t('mcInboundEdit.baseInfo.outboundStorageNoPlaceholder'),
            searchType: 'warehouse',
            // name: 'outboundStorageName',
            // getName: 'storageName',
            // code: 'outboundStorageNo',
            // getCode: 'storageCode',
            required: true,
            currentValue: this.formData.outboundStorageName,
            isMultiple: true,
          }, //原材料出库仓库
          {
            type: 'select',
            prop: 'inboundDepartmentName',
            label: this.$t('mcInboundEdit.baseInfo.inboundDepartmentCode'),
            placeholder: this.$t('mcInboundEdit.baseInfo.inboundDepartmentCodePlaceholder'),
            options: this.departmentList,
            disabled: true,
          }, //部门
          {
            type: 'searchTable',
            prop: 'businessPersonName',
            label: this.$t('mcInboundEdit.baseInfo.businessPersonNo'),
            isMultiple: true,
            // name: 'businessPersonName',
            // getName: 'personName',
            // code: 'businessPersonNo',
            // getCode: 'personNo',
            disabled: true,
            currentValue: this.formData.businessPersonName,
            searchType: 'personnel',
          }, //业务员
          {
            type: 'input',
            label: this.$t('mcInboundEdit.baseInfo.currencyTypeCode'),
            placeholder: this.$t('mcInboundEdit.baseInfo.defaultPlaceholder'),
            prop: 'currencyTypeName',
            currentValue: this.formData.currencyTypeName,
            clearable: true,
            disabled: true,
          }, //币种
          // {
          //   type: "input",
          //   label: this.$t("mcInboundEdit.baseInfo.inboundCreatePersonNo"),
          //   placeholder: this.$t("mcInboundEdit.baseInfo.defaultPlaceholder"),
          //   prop: "inboundCreatePersonName",
          //   currentValue: this.formData.inboundCreatePersonName,
          //   clearable: true,
          //   disabled: true,
          // }, //制单人
          // {
          //   type: "select",
          //   label: this.$t("mcInboundEdit.baseInfo.inboundCompanyCode"),
          //   prop: "inboundCompanyCode",
          //   placeholder: this.$t("mcInboundEdit.baseInfo.inboundCompanyCodePlaceholder"),
          //   options: this.companyList,
          //   relatedColumn: 'none',
          //   changeMethod: "searchCompanyName",
          //   disabled: true,
          // }, //公司
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      rules() {
        return false;
      },
    },
    watch: {
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
      costInfo: {
        handler(newValue) {
          this.formData.inboundQuantity = newValue.inboundQuantity;
          this.formData.settlementPrice = newValue.settlementPrice;
          this.formData.settlementAmount = newValue.settlementAmount;
          console.log(newValue);
          console.log(this.formData);
        },
        deep: true,
      },
    },
    data() {
      return {
        formData: {
          id: '',
          inboundNo: '', //委托加工入库单号
          inboundQuantity: '', //商品入库数量
          settlementPrice: '', //商品单价
          settlementAmount: '', //商品金额
          distributionInboundNo: '', //物流入库单号
          instructionNo: '', //供应商发货指令号
          productDesc: '', //商品描述
          productNo: '', //商品编码
          inboundDate: '', //入库日期
          inboundCreateDate: '', //制单日期
          inboundCreatePersonNo: '', //制单人
          inboundCreatePersonName: '', //制单人
          partnerNo: '', //供应商
          partnerName: '', //供应商
          businessPersonNo: '', //业务员
          businessPersonName: '', //业务员
          inboundCompanyCode: '', //公司
          inboundCompanyName: '', //公司
          inboundDepartmentCode: '', //部门
          inboundDepartmentName: '', //部门
          inboundStorageNo: '', //入库仓库
          outboundStorageNo: '', //出库仓库
          contractQuantity: '', //合同数量
        },
        initFlag: true, //查询详情进入页面时，先不执行handleChange
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      getDetail(data) {
        this.formData = data;
        this.initFlag = true;
        this.$nextTick(() => {
          this.initFlag = false;
        });
      },
      // 根据公司查询部门
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(BASE_API.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
            console.log(this.departmentList);
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      handleChange(v, prop) {
        if (this.canEdit && !this.initFlag) {
          this.formData[prop] = v[prop];
          console.log(v[prop]);
          if (prop == 'inboundStorageName') {
            this.formData.inboundStorageNo = v[prop][0].storageCode || '';
            this.formData.inboundStorageName = v[prop][0].storageName || '';
          } else if (prop == 'outboundStorageName') {
            console.log(v[prop]);
            this.formData.outboundStorageNo = v[prop][0].storageCode || '';
            this.formData.outboundStorageName = v[prop][0].storageName || '';
          } else if (prop == 'partnerName') {
            console.log(v[prop]);
            this.formData.partnerNo = v[prop][0].partnerNo || '';
            this.formData.partnerName = v[prop][0].partnerZhName || '';
          } else if (prop == 'businessPersonName') {
            console.log(v[prop]);
            this.formData.businessPersonName = v[prop][0].personName || '';
            this.formData.businessPersonNo = v[prop][0].personNo || '';
          } else if (prop == 'inboundCompanyCode') {
            console.log(v[prop]);
            this.searchCompanyName(v[prop]);
            // this.formData.inboundCompanyName = v[prop].storageCode
            // this.formData.inboundCompanyCode = v[prop].storageCode
          }
          this.$emit('updateInvoice', this.formData, prop);
          // else if (prop == "exchangeDate") {
          //   this.selectTaxRate();

          // }
        }
      },

      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },

      // 千分位
      toLocaleString(num) {
        return num && num.toLocaleString();
      },
      // 校验
      getVal() {
        return new Promise((resolve, reject) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
